import React from 'react'

import {
  COMBOBOX_FIELD,
  EDITOR_FIELD,
  FILE_FIELD,
  INPUT_FIELD,
  SCORE_FIELD,
  SLIDER_FIELD,
  TEXTAREA_FIELD,
  getField,
} from './model'

export const FormFields = ({
  accept,
  control,
  error,
  field,
  fieldClassName,
  hint,
  id,
  labels,
  max,
  min,
  multiple,
  name,
  options,
  placeholder,
  score,
  step,
  type,
  transformData,
  noOptionsMessage,
  filterOption,
  variables,
  fetchOptions,
  isClearable,
  isCreatable,
  isDisabled,
  isMulti,
  isReadOnly,
  isRequired,
  isSearchable,
  closeMenuOnSelect,
}) => {
  const Component = getField(field)

  const mapFieldToProps = {
    [COMBOBOX_FIELD]: {
      options,
      placeholder,
      fetchOptions,
      filterOption,
      transformData,
      isClearable,
      isCreatable,
      isMulti,
      isReadOnly,
      isSearchable,
      closeMenuOnSelect,
      noOptionsMessage,
    },
    [EDITOR_FIELD]: { variables },
    [FILE_FIELD]: { accept, multiple },
    [INPUT_FIELD]: { placeholder, min, max, type, isReadOnly },
    [SCORE_FIELD]: { score },
    [SLIDER_FIELD]: { labels, max, min, step },
    [TEXTAREA_FIELD]: { placeholder, isReadOnly },
  }

  return (
    <Component
      id={id ?? name}
      {...{
        control,
        error,
        fieldClassName,
        hint,
        name,
        isDisabled,
        isRequired,
      }}
      {...mapFieldToProps[field]}
    />
  )
}
